import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const reAdmissionApi = {
  getReAdmissionList: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.GET_ReAdmission}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  addReAdmission: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.SET_ReAdmission}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },
}

